var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ProfileActionTypes } from "./profile.actions";
import * as fromAuth from "../auth";
import { DefaultProfile, createProfile } from "./profile.model";
export var initialProfileState = {
    loading: true,
    model: __assign({}, DefaultProfile),
    error: null
};
export function profileReducer(state, action) {
    if (state === void 0) { state = initialProfileState; }
    switch (action.type) {
        case fromAuth.AuthActionTypes.AuthTokenPayload:
            return __assign({}, state, { model: createProfile(action.payload) });
        case ProfileActionTypes.ProfileRestore:
            return __assign({}, state, { loading: false, model: __assign({}, action.payload) });
        case ProfileActionTypes.ProfileUpdate:
            return __assign({}, state, { loading: true, model: __assign({}, action.payload) });
        case ProfileActionTypes.ProfileUpdateSuccess:
            return __assign({}, state, { loading: false, error: null });
        case ProfileActionTypes.ProfileUpdateFailure:
            return __assign({}, state, { loading: false, error: action.payload });
        default:
            return state;
    }
}
